<div class="position-relative">
  <div class="container-fluid p-1 p-md-5">

    <!-- ELSA CLAIM BANNER -->
    <div class="row">
      <div class="col-60 py-4 px-5">
        <div class="d-flex flex-column align-items-center align-items-lg-start w-100">
          <img class="product-in-evidence-banner"
               src="https://media.elsasrl.com/storage/elsa-platform/media/be-xtra/home-bnnr-write.png"
               alt="Elsa banner"/>
        </div>
      </div>
    </div>

    <div class="row m-3">
      <!-- ELSA PRODUCT IN EVIDENCE IMAGE -->
      <div class="col-60 col-lg-34">
        <div class="d-flex flex-column align-items-center w-100 product-image-container">
          <img *ngIf="serie" [src]="serie?.image_header.path" class="product-in-evidence-image mt-2" [alt]="serie?.name">
        </div>
      </div>

      <!-- ELSA PRODUCT IN EVIDENCE DESCRIPTION -->
      <div class="col-60 col-lg-26 mt-3 mt-lg-0 text-center text-lg-left">
        <h2 class="product-in-evidence-title">Supercombinata®</h2>
        <h3 class="product-in-evidence-subtitle font-weight-regular">The Unique Combo One</h3>
        <p class="product-in-evidence-description mt-2" [innerHTML]="serie?.description | safeHtml"></p>
        <button class="btn product-in-evidence-button btn-green text-uppercase"
                [routerLink]="Paths.Products | page | localize">{{'label_go_to_products' | translate}}
        </button>
      </div>
    </div>
  </div>
  <div class="product-in-evidence-background"></div>
</div>
